import * as React from "react"
import { PageProps, Link, graphql } from "gatsby"

import Blog from "../components/blog"
import Seo from "../components/seo"
import { StaticImage } from "gatsby-plugin-image"

type DataProps = {
  site: {
    buildTime: string
  }
}

const Mesinkasirtoko: React.FC<PageProps<DataProps>> = ({ data, path }) => (
  <Blog>
    <Seo title="Mesin Kasir Toko" />
    <h1><strong><a href="/mesinkasirtoko/">Mesin Kasir Toko</a></strong></h1>
<img className="img-fluid" alt="Mesin Kasir Toko Minimarket" src="/img/mesinkasironlineapp2.jpg"/>
    <p>
Kemudahan kestabilan efisiensi tahan lama dalam digunakan , dengan menggunakan point of sale <a href="/mesinkasirtoko/">mesin kasir toko</a> produk kami ini akan memudahkan dalam setiap pekerjaan, bu default pada paket lengkap ini sudah tersedia dengan program software toko yang siap pakai, sehingga tinggal pasang port hardware pernagkat kasir dan dengan system plug and play ready untuk terminal device <a href="/mesinkasirtoko/">mesin kasir toko</a> bekerja. kemudahan system , kelengkapan fitur dan laporan detail benar benar semakin mobile untuk mendukung pekerjaan anda, dan  kini saatnya menggunakan real pos point of sale dalam bekerja agar daya tahan peremajaan untuk jangka waktu lama dalam beroperasi hingga kestabilan system nya. mulai beralih ke pos system hardware technology untuk lebih baik.  
    </p>
<p>Pelajari bagaimana device hardware ini bekerja dengan sempurna untuk point of sale pos kasir dan pembukuan.</p>

<div className="col-md-12 p-3 p-md-5">
<ul class="nav nav-pills mb-3" id="pills-tab">
  <li class="nav-item p-1" role="presentation">
    <button class="btn btn-dark btn-sm active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Intro</button>
  </li>
  <li class="nav-item p-1" role="presentation">
    <button class="btn btn-dark btn-sm" id="pills-demokasir-tab" data-bs-toggle="pill" data-bs-target="#pills-demokasir" type="button" role="tab" aria-controls="pills-demokasir" aria-selected="false">Demo</button>
  </li>
  <li class="nav-item p-1" role="presentation">
    <button class="btn btn-dark btn-sm" id="pills-online-tab" data-bs-toggle="pill" data-bs-target="#pills-online" type="button" role="tab" aria-controls="pills-online" aria-selected="false">Online</button>
  </li>
  <li class="nav-item p-1" role="presentation">
    <button class="btn btn-dark btn-sm" id="pills-barcode-tab" data-bs-toggle="pill" data-bs-target="#pills-barcode" type="button" role="tab" aria-controls="pills-barcode" aria-selected="false">Barcode</button>
  </li>
</ul>
<div class="tab-content" id="pills-tabContent">
  <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
   <p>Dukungan technology penuh dari ASUS untuk all in one touchscreen tersemat, slim desain fashionable super mewah dengan harga terjangkau untuk anda, bersama pos device terminal ini maka sensasi elegan luxury untuk display kasir pos menambah wibawa usaha bisnis, dukungan multiport menyempurnakan nya bekerja dengan berbagai peralatan kasir dan tentunya sudah termasuk installasi setting sehingga <a href="/mesinkasirtoko/">mesin kasir toko</a> siap digunakan di tempat anda.</p>
  <p>
  Semakin menyempurnakan dalam bekerja dengan kemampuan nya secara fungsional dalam penggunaan single standalone mesin kasir tunggal untuk mendukung berbagai pekerjaan , selanjutnya dengan kemampuan secara
  penuh bekerja dengan pembagian divisi untuk bekerja seperti kebutuhan divisi gudang yang khusus menerima data barang produk masuk , melakukan inventori management , cek laporan persediaan barang stok, konversi stok terbesar menjadi stok eceran, 
  stok opname, memasukan data produk persediaan include dengan barcode dan gambar, setting harga beli dan jual, dan berbagai kebutuhan gudang lain nya, selanjutnya kemampuan kasir secara fungsional digunakan dalam 
  kebutuhan dan fokus pada penjualan kasir point of sale dengan metode barcode system maupun touchscreen layar sentuh, melakukan editing penjualan, retur , menghapus dan berbagai kebutuhan lain nya. Selanjutnya 
  memudahkan admin backoffice untuk cek laporan laporan detail dalam konsep skema bekerja secara divisi lan jaringan system.
  </p>
  <p>
  Penggunaan skema dan konsep system dengan metode offline desktop yang bekerja secara local area tanpa membutuhkan koneksi internet , dan memiliki kemampuan digunakan dengan share data via penggunaan kabel lan , 
  wifi system untuk kebutuhan pembagian divisi dan membagi data, selain itu juga memiliki fungsional penuh dengan menggunakan online metode untuk bekerja , demi memudahkan owner cek laporan dimana saja dan kapan saja via berbagai device digunakan. 
  integrasi dengan website toko secara langsung dengan web app, aplikasi android untuk owner cek laporan, aplikasi android frontend untuk pelanggan agar mendapatkan informasi dari toko, semakin memudahkan memilih konsep 
  system sesuai dengan kebutuhan bisnis retail minimarket dan toko dalam bekerja.
  </p>
  </div>
  <div class="tab-pane fade" id="pills-demokasir" role="tabpanel" aria-labelledby="pills-demokasir-tab">
  <div class="ratio ratio-16x9">
  <iframe width="560" height="315" className="rounded" src="https://www.youtube.com/embed/zQIjZPnGthc" title="mesin kasir toko"></iframe>
</div>
  </div>
  <div class="tab-pane fade" id="pills-online" role="tabpanel" aria-labelledby="pills-online-tab">
  <div class="ratio ratio-16x9">
  <iframe width="560" height="315" className="rounded" src="https://www.youtube.com/embed/foa0IlLn_yw" title="mesin kasir online toko"></iframe>
</div>
  </div>
  <div class="tab-pane fade" id="pills-barcode" role="tabpanel" aria-labelledby="pills-barcode-tab">
  <div class="ratio ratio-16x9">
  <iframe width="560" height="315" className="rounded" src="https://www.youtube.com/embed/hzXc74f5KP8" title="mesin kasir toko barcode"></iframe>
</div>
</div>
  </div>
</div>

    <p>Mulai pilih <a href="/mesinkasirtoko/">mesin kasir toko</a> mu sekarang dan mulai upgrade technology bersama kami.</p>
<div className="row">
    <div className="p-3 p-md-5 col-12 col-md-4">
<StaticImage
src="../img/TOUCHSCREEN2.webp"
className="img-fluid mt-3 mb-3"
loading="eager" 
id="start"
width={500}
quality={95}
formats={["auto", "webp", "avif", "svg"]}
alt="mesin kasir toko minimarket shop"
/>
<p>
    Version 2<br/>
 All in one touchscreen pos + printer kasir auto cutter + program software toko.</p>
 <small>Rp.10.062.400</small><br/>
<a href="https://wa.me/6285646104747?text=Admin%20saya%20mau%20order%20Mesin%20Kasir%0ANama/Usaha%20%3A%0AAlamat%20%3A%0APaket%20Versi%20%3A%20Dua%0APrice%20%3A%20Rp.10.062.400%0APembayaran%20via%20%3A%0ABCA%200181884109 %20Suci%20Chanifah%0A%0Atolong%20diproses%20pesanan%20saya" className="button col-12">Buy Now</a>
    </div>
    <div className="p-3 p-md-5 col-12 col-md-4">
<StaticImage
src="../img/TOUCHSCREEN3.webp"
className="img-fluid mt-3 mb-3"
loading="eager" 
id="start"
width={500}
quality={95}
formats={["auto", "webp", "avif", "svg"]}
alt="mesin kasir toko minimarket shop"
/>
<p>
    Version 3<br/>
 All in one touchscreen pos + printer kasir auto cutter + cash drawer laci kasir + program software toko.</p>
 <small>Rp.11.046.800</small><br/>
<a href="https://wa.me/6285646104747?text=Admin%20saya%20mau%20order%20Mesin%20Kasir%0ANama/Usaha%20%3A%0AAlamat%20%3A%0APaket%20Versi%20%3A%20Tiga%0APrice%20%3A%20Rp.11.046.800%0APembayaran%20via%20%3A%0ABCA%200181884109 %20Suci%20Chanifah%0A%0Atolong%20diproses%20pesanan%20saya" className="button col-12">Buy Now</a>
    </div>
    <div className="p-3 p-md-5 col-12 col-md-4">
<StaticImage
src="../img/TOUCHSCREEN4.webp"
className="img-fluid mt-3 mb-3"
loading="eager" 
id="start"
width={500}
quality={95}
formats={["auto", "webp", "avif", "svg"]}
alt="mesin kasir toko minimarket shop"
/>
<p>
    Version 4<br/>
 All in one touchscreen pos + printer kasir auto cutter + cash drawer laci kasir + laser barcode manual + program software toko.</p>
 <small>Rp.12.032.600</small><br/>
<a href="https://wa.me/6285646104747?text=Admin%20saya%20mau%20order%20Mesin%20Kasir%0ANama/Usaha%20%3A%0AAlamat%20%3A%0APaket%20Versi%20%3A%20Empat%0APrice%20%3A%20Rp.12.032.600%0APembayaran%20via%20%3A%0ABCA%200181884109 %20Suci%20Chanifah%0A%0Atolong%20diproses%20pesanan%20saya" className="button col-12">Buy Now</a>
    </div>
    <div className="p-3 p-md-5 col-12 col-md-6">
<StaticImage
src="../img/TOUCHSCREEN5.webp"
className="img-fluid mt-3 mb-3"
loading="eager" 
id="start"
width={500}
quality={95}
formats={["auto", "webp", "avif", "svg"]}
alt="mesin kasir toko minimarket shop"
/>
<p>
    Version 5<br/>
    All in one touchscreen pos + printer kasir auto cutter + cash drawer laci kasir + laser barcode auto multi laser + program software toko.</p>
    <small>Rp.14.547.800</small><br/>
<a href="https://wa.me/6285646104747?text=Admin%20saya%20mau%20order%20Mesin%20Kasir%0ANama/Usaha%20%3A%0AAlamat%20%3A%0APaket%20Versi%20%3A%20Lima%0APrice%20%3A%20Rp.14.547.800%0APembayaran%20via%20%3A%0ABCA%200181884109 %20Suci%20Chanifah%0A%0Atolong%20diproses%20pesanan%20saya" className="button col-12">Buy Now</a>
    </div>
    <div className="p-3 p-md-5 col-12 col-md-6">
   <StaticImage
src="../img/TOUCHSCREEN6.webp"
className="img-fluid mt-3 mb-3"
loading="eager" 
id="start"
width={500}
quality={95}
formats={["auto", "webp", "avif", "svg"]}
alt="mesin kasir toko minimarket shop"
/>
<p>
    Version 6<br/>
    All in one touchscreen pos + printer kasir auto cutter + cash drawer laci kasir + laser barcode auto multi laser + mesin cetak barcode + program software toko.</p>
    <small>Rp.18.534.200</small><br/>
<a href="https://wa.me/6285646104747?text=Admin%20saya%20mau%20order%20Mesin%20Kasir%0ANama/Usaha%20%3A%0AAlamat%20%3A%0APaket%20Versi%20%3A%20Enam%0APrice%20%3A%20Rp.18.534.200%0APembayaran%20via%20%3A%0ABCA%200181884109 %20Suci%20Chanifah%0A%0Atolong%20diproses%20pesanan%20saya" className="button col-12">Buy Now</a>
    </div>
    

    </div>
    <Link to="/">Go back to the homepage</Link>
  </Blog>
)

export default Mesinkasirtoko

export const query = graphql`
  {
    site {
      buildTime(formatString: "YYYY-MM-DD hh:mm a z")
    }
  }
`
